var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Available Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List/Opportunity/-Avaialable",
    transform: "translate(-24.000000, -6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Available-Icon",
    transform: "translate(24.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2C8234",
    cx: 8.5,
    cy: 8.5,
    r: 8.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star",
    fill: "#FFFFFF",
    points: "8.5 11 5.56107374 12.545085 6.12235871 9.27254249 3.74471742 6.95491503 7.03053687 6.47745751 8.5 3.5 9.96946313 6.47745751 13.2552826 6.95491503 10.8776413 9.27254249 11.4389263 12.545085"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleStar);
export default __webpack_public_path__ + "static/media/circleStar.7270d0283b3321932e30f84e925330ed.svg";
export { ForwardRef as ReactComponent };